export default __webpack_public_path__ + "static/media/EM1070.34I-39273_-23254_0.63129020.jpg";